import type { OperationalDashboardViewModel } from "../utils/crmOperationalDashboard.aggregate";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/crm/pro/" });

/**
 * Loads the CRM Pro operational dashboard in a single round-trip. The backend applies the caller's
 * view-all / view-assigned scope, so KPI counts always agree with the Leads list.
 */
export async function fetchOperationalDashboard(): Promise<OperationalDashboardViewModel> {
  const { data } = await api.get("/dashboard/operational");
  return data;
}
